<template>
  <div class="animated fadeIn">
    <basic-heading title="Instrument Runner" class="mb-3" />
    <DatePicker @date_change="(val) => selected_date = val" />
    <InstrumentRunnerSchedulePicker :selected_date="selected_date" />
  </div>
</template>

<script>
import BasicHeading from "@/components/shared/BasicHeading";
import InstrumentRunnerCardstack from "@/components/lab/instrumentrunner/InstrumentRunnerCardstack";
import DatePicker from "@/components/shared/DatePicker.vue";
import InstrumentRunnerSchedulePicker from "@/components/lab/instrumentrunner/InstrumentRunnerSchedulePicker.vue";

  export default {
    name: "InstrumentRunnerIndex",
    components: { 
      BasicHeading,
      InstrumentRunnerCardstack,
      DatePicker,
      InstrumentRunnerSchedulePicker,
    },
    data() {
      return {
        selected_date: null
      };
    },
  }
</script>